"use client";

import dynamic from "next/dynamic";

export const GeoSelectorModal = dynamic(() =>
	import("./GeoSelector").then((mod) => mod.GeoSelectorModal),
);

export const GeoSelectorTrigger = dynamic(() =>
	import("./GeoSelector").then((mod) => mod.GeoSelectorTrigger),
);
